import { render, staticRenderFns } from "./ResponsivePage.vue?vue&type=template&id=452f38f0&scoped=true&"
import script from "./ResponsivePage.vue?vue&type=script&lang=js&"
export * from "./ResponsivePage.vue?vue&type=script&lang=js&"
import style0 from "./ResponsivePage.vue?vue&type=style&index=0&id=452f38f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452f38f0",
  null
  
)

export default component.exports